export default "__VITE_ASSET__ca483dd9__"